import { render, staticRenderFns } from "./SunoVerifyCode.vue?vue&type=template&id=56a8c80a&scoped=true"
import script from "./SunoVerifyCode.vue?vue&type=script&lang=js"
export * from "./SunoVerifyCode.vue?vue&type=script&lang=js"
import style0 from "./SunoVerifyCode.vue?vue&type=style&index=0&id=56a8c80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8c80a",
  null
  
)

export default component.exports